import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpModule } from '@angular/http';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MyApp } from './app.component';
import { OneSignal } from '@ionic-native/onesignal/ngx';
import { IonicStorageModule } from '@ionic/storage';
import { CalendarModule } from '../components/calendar/calendar.module';
import { DatePickerModule } from 'ionic3-datepicker';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HttpClientModule } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Camera } from '@ionic-native/camera';
import { SocialSharing } from '@ionic-native/social-sharing';
import { Ng2ImgToolsModule } from 'ng2-img-tools';
import { IonicImageViewerModule } from 'ionic-img-viewer';
import { ChartsModule } from 'ng2-charts';
import { SuperTabsModule } from 'ionic2-super-tabs';
import { ImageResizer } from '@ionic-native/image-resizer';
import { Network } from '@ionic-native/network';
import { Contacts } from '@ionic-native/contacts';

import { PermissionCheckPipe } from '../pipes/permission-check/permission-check';
import { SafePipe } from '../pipes/safe/safe';
import { StatusFilterPipe } from '../pipes/status/status';
import { SanitizePipe } from '../pipes/sanitize/sanitize';

import { LoginProvider } from '../providers/login/login';
import { DashboardPage } from '../pages/dashboard/dashboard';
// import { SignUpTabsPage } from '../pages/sign-up-tabs/sign-up-tabs';
import { SignUpNumberPage } from '../pages/sign-up-number/sign-up-number';
import { SignUpFormPage } from '../pages/sign-up-form/sign-up-form';
import { SignUpOtpPage } from '../pages/sign-up-otp/sign-up-otp';
import { OtpLoginPage } from '../pages/otp-login/otp-login';
import { ComplaintTabsPage } from '../pages/complaint-tabs/complaint-tabs';
import { OpenComplaintsPage } from '../pages/open-complaints/open-complaints';
import { ClosedComplaintsPage } from '../pages/closed-complaints/closed-complaints';
import { AllComplaintsPage } from '../pages/all-complaints/all-complaints';
import { ComplaintsProvider } from '../providers/complaints/complaints';
import { ComplaintsDetailsPage } from '../pages/complaints-details/complaints-details';
import { AddComplaintsPage } from '../pages/add-complaints/add-complaints';
import { AddComplaintsFormPage } from '../pages/add-complaints-form/add-complaints-form';
import { CreatePassPage } from '../pages/create-pass/create-pass';
import { PassPage } from '../pages/pass/pass';
import { VisitListPage } from '../pages/visit-list/visit-list';
import { VisitorTabsPage } from '../pages/visitor-tabs/visitor-tabs';
import { VisitorProvider } from '../providers/visitor/visitor';
import { VisitDetailPage } from '../pages/visit-detail/visit-detail';
import { ToastProvider } from '../providers/toast/toast';
import { NoticesPage } from '../pages/notices/notices';
import { NoticesProvider } from '../providers/notices/notices';
import { NoticeDetailsPage } from '../pages/notice-details/notice-details';
import { PopoverPage } from '../pages/popover/popover';
import { ProfilePage } from '../pages/profile/profile';
import { ProfileDetailPage } from '../pages/profile-detail/profile-detail';
import { VehicleDetailPage } from '../pages/vehicle-detail/vehicle-detail';
import { ForgotPassPage } from '../pages/forgot-pass/forgot-pass';
import { ResidentIdCardPage } from '../pages/resident-id-card/resident-id-card';
import { BillingPaymentsPage } from '../pages/billing-payments/billing-payments';
import { BillingListPage } from '../pages/billing-list/billing-list';
import { PaymentListPage } from '../pages/payment-list/payment-list';
import { BillingPaymentsProvider } from '../providers/billing-payments/billing-payments';
import { AccountSummaryPage } from '../pages/account-summary/account-summary';
import { BillReportPage } from '../pages/bill-report/bill-report';
import { PaymentDetailPage } from '../pages/payment-detail/payment-detail';
import { MeterPage } from '../pages/meter/meter';
import { MeterReadingPage } from '../pages/meter-reading/meter-reading';
import { ConsumptionChartPage } from '../pages/consumption-chart/consumption-chart';
import { MeterProvider } from '../providers/meter/meter';
import { MySocietyPage } from '../pages/my-society/my-society';
import { FeedbackPage } from '../pages/feedback/feedback';
import { AboutUsPage } from '../pages/about-us/about-us';
import { MyStaffTabsPage } from '../pages/my-staff-tabs/my-staff-tabs';
import { MyStaffPage } from '../pages/my-staff/my-staff';
import { StaffDetailPage } from '../pages/staff-detail/staff-detail';
import { SearchStaffPage } from '../pages/search-staff/search-staff';
import { StaffProvider } from '../providers/staff/staff';
import { MobileAppService } from '../services/mobile-app';
import { AttendancePage } from '../pages/attendance/attendance';
import { SettingsPage } from '../pages/settings/settings';
import { SettingsProvider } from '../providers/settings/settings';
import { AppSearchItemsProvider } from '../providers/app-search-items/app-search-items';
import { AppSearchPage } from '../pages/app-search/app-search';
import { PanicPage } from '../pages/panic/panic';
import { ExtraProvider } from '../providers/extra/extra';
import { ForgotPasswordPage } from '../pages/forgot-password/forgot-password';
import { HandleNotificationService } from '../services/handle-notification';
import { Calendar } from '../components/calendar/calendar';
import { FileChooser } from '@ionic-native/file-chooser';
import { ImagePicker } from '@ionic-native/image-picker'
import { FilePath } from '@ionic-native/file-path';
import { IOSFilePicker } from '@ionic-native/file-picker';
import { Base64 } from '@ionic-native/base64';
import { File } from '@ionic-native/file';
import { NotificationsPage } from '../pages/notifications/notifications';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { UtilService } from '../services/util';
import { NetworkServices } from '../services/network-services';
import { SettingService } from '../services/setting-service';
import { MakePaymentPage } from '../pages/make-payment/make-payment';
import { MembersPage } from '../pages/members/members';
import { AddMemberPage } from '../pages/add-member/add-member';
import { VisitorModalPage } from '../pages/visitor-modal/visitor-modal';
import { Keyboard } from '@ionic-native/keyboard';
import { SurveyProvider } from '../providers/survey/survey';
import { SurveyPage } from '../pages/survey/survey';
import { SurveyDetailPage } from '../pages/survey-detail/survey-detail';
import { SendPasswordPage } from '../pages/send-password/send-password';
import { MarkCloseModalPage } from '../pages/mark-close-modal/mark-close-modal';
import { CustomdatePipe } from '../pipes/customdate/customdate';
import { SurveyModalPage } from '../pages/survey-modal/survey-modal';
import { UpdateModalPage } from '../pages/update-modal/update-modal';
import { PassPurposePage } from '../pages/pass-purpose/pass-purpose';
import { FacilityPage } from '../pages/facility/facility';
import { FacilityProvider } from '../providers/facility/facility';
import { FacilitySelectLocationPage } from '../pages/facility-select-location/facility-select-location';
import { BookingPage } from '../pages/booking/booking';
import { AllBookingsPage } from '../pages/all-bookings/all-bookings';
import { GeneratePassPage } from '../pages/generate-pass/generate-pass';
import { HowItWorksPage } from '../pages/how-it-works/how-it-works';
import { SelectionModalPage } from '../pages/selection-modal/selection-modal';
import { PassDetailPage } from '../pages/pass-detail/pass-detail';
import { SharePassPage } from '../pages/share-pass/share-pass';
import { VehicleProvider } from '../providers/vehicle/vehicle';
import { MyVehiclePage } from '../pages/my-vehicle/my-vehicle';
import { AddVehiclePage } from '../pages/add-vehicle/add-vehicle';
import { VehicleAccessLogPage } from '../pages/vehicle-access-log/vehicle-access-log';
import { SmartLockProvider } from '../providers/smart-lock/smart-lock';
import { SmartLockPage } from '../pages/smart-lock/smart-lock';
import { SmartLockLogPage } from '../pages/smart-lock-log/smart-lock-log';
import { SmartLockTabsPage } from '../pages/smart-lock-tabs/smart-lock-tabs';
import { MarketPlacePage } from '../pages/market-place/market-place';
import { SingleMarketPlacePage } from '../pages/single-market-place/single-market-place';
import { MarketplacecategoryPage } from '../pages/marketplacecategory/marketplacecategory';
import { MarketplacereviewmodalPage } from '../pages/marketplacereviewmodal/marketplacereviewmodal';
import { MarketplacesearchPage } from '../pages/marketplacesearch/marketplacesearch';
import { IvrModalPage } from '../pages/ivr-modal/ivr-modal';
import { MarketplaceProvider } from '../providers/marketplace/marketplace';
import { MarketPlacePageModule } from '../pages/market-place/market-place.module';
import { MarketplaceAddOfferPage } from '../pages/marketplace-add-offer/marketplace-add-offer';
import { ExportMeterPage } from '../pages/export-meter/export-meter';
import { SignUpProvider } from '../providers/sign-up/sign-up';
import { TermsAndConditionPage } from '../pages/terms-and-condition/terms-and-condition'
import { TemplateDetailsPage } from '../pages/template-details/template-details'
// import { Downloader } from '@ionic-native/downloader/ngx'
import { VehicleTagPage } from '../pages/vehicle-tag/vehicle-tag';
import { ReferralPage } from '../pages/referral/referral';
import { RequestListPage} from '../pages/request-list/request-list';
import { UpdateProfileFormPage } from '../pages/update-profile/update-profile-form';
import { EventDetailsPage } from '../pages/event-details/event-details';
import { EventsPage } from '../pages/Event/event';
import { SQLite } from '@ionic-native/sqlite/ngx';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    MyApp,
    DashboardPage,
    // SignUpTabsPage,
    SignUpFormPage,
    SignUpNumberPage,
    SignUpOtpPage,
    OtpLoginPage,
    ComplaintTabsPage,
    OpenComplaintsPage,
    ClosedComplaintsPage,
    AllComplaintsPage,
    ComplaintsDetailsPage,
    AddComplaintsPage,
    AddComplaintsFormPage,
    CreatePassPage,
    PassPage,
    VisitListPage,
    VisitorTabsPage,
    VisitDetailPage,
    NoticesPage,
    EventsPage,
    EventDetailsPage,
    NoticeDetailsPage,
    PopoverPage,
    ProfilePage,
    ProfileDetailPage,
    VehicleDetailPage,
    VehicleTagPage,
    ForgotPassPage,
    ResidentIdCardPage,
    BillingPaymentsPage,
    PaymentListPage,
    BillingListPage,
    AccountSummaryPage,
    BillReportPage,
    PaymentDetailPage,
    MeterPage,
    ConsumptionChartPage,
    MeterReadingPage,
    MySocietyPage,
    FeedbackPage,
    AboutUsPage,
    PermissionCheckPipe,
    StatusFilterPipe,
    SanitizePipe,
    SafePipe,
    MyStaffTabsPage,
    MyStaffPage,
    StaffDetailPage,
    SearchStaffPage,
    AttendancePage,
    SettingsPage,
    AppSearchPage,
    PanicPage,
    ForgotPasswordPage,
    NotificationsPage,
    MakePaymentPage,
    MembersPage,
    AddMemberPage,
    VisitorModalPage,
    SurveyPage,
    SurveyDetailPage,
    SendPasswordPage,
    MarkCloseModalPage,
    CustomdatePipe,
    SurveyModalPage,
    UpdateModalPage,
    PassPurposePage,
    FacilityPage,
    FacilitySelectLocationPage,
    BookingPage,
    AllBookingsPage,
    GeneratePassPage,
    HowItWorksPage,
    SelectionModalPage,
    PassDetailPage,
    SharePassPage,
    PassDetailPage,
    MyVehiclePage,
    AddVehiclePage,
    VehicleAccessLogPage,
    MarketPlacePage,
    SingleMarketPlacePage,
    MarketplacecategoryPage,
    MarketplacereviewmodalPage,
    MarketplacesearchPage,
    MarketplaceAddOfferPage,
    SmartLockPage,
    SmartLockLogPage,
    SmartLockTabsPage,
    IvrModalPage,
    ExportMeterPage,
    TermsAndConditionPage,
    TemplateDetailsPage,
    ReferralPage,
    RequestListPage,
    UpdateProfileFormPage,
    
  ],
  imports: [
    CalendarModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SuperTabsModule.forRoot(),
    IonicModule.forRoot(MyApp, {
      tabsHideOnSubPages: true
    }),
    IonicStorageModule.forRoot(),
    HttpModule,
    Ng2ImgToolsModule,
    IonicImageViewerModule,
    ChartsModule,
    DatePickerModule,
    MarketPlacePageModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    DashboardPage,
    SignUpFormPage,
    SignUpNumberPage,
    SignUpOtpPage,
    // SignUpTabsPage,
    OtpLoginPage,
    ComplaintTabsPage,
    OpenComplaintsPage,
    ClosedComplaintsPage,
    AllComplaintsPage,
    ComplaintsDetailsPage,
    AddComplaintsPage,
    AddComplaintsFormPage,
    CreatePassPage,
    PassPage,
    VisitListPage,
    VisitorTabsPage,
    VisitDetailPage,
    NoticesPage,
    EventsPage,
   EventDetailsPage,
    NoticeDetailsPage,
    PopoverPage,
    ProfilePage,
    ProfileDetailPage,
    VehicleDetailPage,
    VehicleTagPage,
    ForgotPassPage,
    ResidentIdCardPage,
    BillingPaymentsPage,
    PaymentListPage,
    BillingListPage,
    AccountSummaryPage,
    BillReportPage,
    PaymentDetailPage,
    MeterPage,
    MeterReadingPage,
    ConsumptionChartPage,
    FeedbackPage,
    AboutUsPage,
    MySocietyPage,
    MyStaffTabsPage,
    MyStaffPage,
    StaffDetailPage,
    SearchStaffPage,
    AttendancePage,
    SettingsPage,
    AppSearchPage,
    PanicPage,
    ForgotPasswordPage,
    Calendar,
    NotificationsPage,
    MakePaymentPage,
    MembersPage,
    AddMemberPage,
    VisitorModalPage,
    SurveyPage,
    SurveyDetailPage,
    SendPasswordPage,
    MarkCloseModalPage,
    SurveyModalPage,
    UpdateModalPage,
    PassPurposePage,
    FacilityPage,
    FacilitySelectLocationPage,
    BookingPage,
    AllBookingsPage,
    GeneratePassPage,
    HowItWorksPage,
    SelectionModalPage,
    PassDetailPage,
    SharePassPage,
    PassDetailPage,
    MyVehiclePage,
    AddVehiclePage,
    VehicleAccessLogPage,
    MarketPlacePage,
    SingleMarketPlacePage,
    MarketplacecategoryPage,
    MarketplacereviewmodalPage,
    MarketplacesearchPage,
    MarketplaceAddOfferPage,
    SmartLockPage,
    SmartLockLogPage,
    SmartLockTabsPage,
    IvrModalPage,
    ExportMeterPage,
    TermsAndConditionPage,
    TemplateDetailsPage,
    ReferralPage,
    RequestListPage,
    UpdateProfileFormPage,
    
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    StatusBar, SplashScreen, Camera,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    LoginProvider,
    ComplaintsProvider,
    VisitorProvider,
    ToastProvider,
    NoticesProvider,
    BillingPaymentsProvider,
    MeterProvider,
    StaffProvider,
    MobileAppService,
    HandleNotificationService,
    OneSignal,
    SettingsProvider,
    AppSearchItemsProvider,
    ExtraProvider,
    FileChooser,
    FilePath,
    Base64,
    File,
    InAppBrowser,
    UtilService,
    NetworkServices,
    SettingService,
    Keyboard,
    SurveyProvider,
    ImageResizer,
    Network,
    ImagePicker,
    SocialSharing,
    FacilityProvider,
    VehicleProvider,
    Contacts,
    SmartLockProvider,
    MarketplaceProvider,
    SignUpProvider,
    IOSFilePicker,
    PermissionCheckPipe,
    StatusFilterPipe,
    SanitizePipe,
    SQLite
    // Downloader
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts